
import moment from "moment-jalali";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import { useHistory } from "react-router-dom";
import { setDialog } from "../store/api/Modals";
import "react-datepicker2/src/styles/style.css";
import { useSelector, useDispatch } from "react-redux";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { getAllProvinces, getCityList } from "../store/api/LocationAPI";
import ModalChangeCustomerStatus from "../Components/Customer/ModalChangeCustomerStatus";
import { CardText, Envelope, EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Search, TelephoneOutbound, Toggles2 } from "react-bootstrap-icons";
import { searchCustomer, deleteCustomer, getCustomerBaseInfoes, searchCustomer_GetMobiles } from "../store/api/CustomerApi";
import ModalSendSMS from "../../Components/Modals/ModalSendSMS";
import { clickToCall, exportToExcel, setErrorDialog } from "../../store/api/CommonFunctions";
import ModalNewNotice from "../../Components/Modals/ModalNewNotice";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchCustomer = () => {
    const createDateTo = useRef();
    const updateDateTo = useRef();
    const dispatch = useDispatch();
    const updateDateFrom = useRef();
    const createDateFrom = useRef();
    const { handleSubmit, register } = useForm();
    const [createBy, setCreateBy] = useState({});
    const [updateBy, setUpdateBy] = useState({});
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [selectedCust, setSelectedCust] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState("");
    const [modalSMS, setModalSMS] = useState({ show: false });
    const [modalUsers, setModalUsers] = useState({ show: false });
    const [showChangeStatus, setChangeStatusPop] = useState(false);
    const [modalNoticeData, setModalNoticeData] = useState({ show: false });
    const { baseInfoes, provinceList, cityList, filterData } = useSelector(state => {
        return {
            baseInfoes: state.customerDataReducer.customerBaseInfoes,
            filterData: state.customerDataReducer.custSearchFilter,
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList
        }
    });
    const searchData = useRef({
        CreateDateFrom: filterData?.CreateDateFrom,
        CreateDateTo: filterData?.CreateDateTo,
        UpdateDateFrom: filterData?.UpdateDateFrom,
        UpdateDateTo: filterData?.UpdateDateTo
    });
    const search = (data) => {
        data.Skip = 0;
        data.Take = 10;
        if (Number(data.JobId) > 0) {
            data.Job = baseInfoes.JobList.find(j => Number(j.JobId) === Number(data.JobId))?.Job
        }
        data.CreateByID = createBy.ID;
        data.UpdateByID = updateBy.ID;
        if (createDateFrom.current.input.value !== "") {
            data.CreateDateFrom = searchData.current.CreateDateFrom;
        }
        if (createDateTo.current.input.value !== "") {
            data.CreateDateTo = searchData.current.CreateDateTo;
        }
        if (updateDateFrom.current.input.value !== "") {
            data.UpdateDateFrom = searchData.current.UpdateDateFrom;
        }
        if (updateDateTo.current.input.value !== "") {
            data.UpdateDateTo = searchData.current.UpdateDateTo;
        }
        dispatch(searchCustomer(data));
    }
    const history = useHistory();
    const showCustomer = (id) => {
        history.push("/CRM/AddEditCustomer/" + id);
    }
    const loadCityList = (provinceID) => {
        searchData.current.ProvinceID = provinceID;
        dispatch(getCityList(provinceID));
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد مشتری", colName: "Code", showInMobile: true },
        { colTitle: "کد اشتراک", colName: "SubscriptionCode", showInMobile: true },
        { colTitle: "نام مشتری", colName: "FirstName", showInMobile: true },
        { colTitle: "نام خانوادگی", colName: "Name", showInMobile: true },
        {
            colTitle: "تلفن", colName: "Phone", showInMobile: false,
            button: {
                icon: <TelephoneOutbound size={14} className="rowBtn" color="#007a80" />,
                onClick: (item) => call(item.Phone),
                showCondition: item => item.Phone?.length > 3
            }
        },
        {
            colTitle: "همراه", colName: "Mobile", showInMobile: false,
            button: {
                icon: <TelephoneOutbound size={14} className="rowBtn" color="#007a80" />,
                onClick: (item) => call(item.Mobile),
                showCondition: item => item.Mobile?.length > 9
            }
        },
        { colTitle: "استان", colName: "ProvinceName", showInMobile: false },
        { colTitle: "شهر", colName: "CityName", showInMobile: false },
        { colTitle: "آدرس", colName: "Address", showInMobile: false, colType: "string", maxTextLength: 100 }
    ]
    const tableRowButtons = [
        {
            title: "حذف مشتری", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف مشتری',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteCustomer(item.ID, () => { dispatch(searchCustomer(filterData)); })
                }))
            }
        },
        {
            title: "کمپین", type: "common", icon: <Toggles2 size={20} color="#b10e9d" className="rowBtn" />, className: " group-Btn-smalll", onclick: (item) => changeStatus(item)
        },
        {
            title: "اطلاعیه", type: "common", icon: <CardText size={20} color="blue" className="rowBtn" />, className: "group-Btn-smalll btn-secondary", onclick: (item) => showModalNotice(item.Code)
        }

    ]
    const changeStatus = (c) => {
        const customer = {};
        customer.ID = c.ID;
        customer.CustOrPreCust = "مشتری";
        setSelectedCampaign(c.CampaignID);
        setSelectedCust([customer]);
        setChangeStatusPop(true);
    }
    const showCreateBy = () => {
        if (filterData)
            filterData.CreateByID = null;
        const setData = (data) => {
            if (data?.ID) {
                setCreateBy(data);
            }
            else {
                setCreateBy({ Name: " " });
            }
        }
        setModalUsers({ show: true, selectUserWithName: setData });
    }
    const showUpdateBy = () => {
        if (filterData)
            filterData.UpdateByID = null;
        const setData = (data) => {
            if (data?.ID) {
                setUpdateBy(data);
            }
            else {
                setUpdateBy({ Name: " " });
            }
        }
        setModalUsers({ show: true, selectUserWithName: setData });
    }
    function call(callNumber) {
        callNumber = callNumber.replace(" ", "");
        if (!callNumber || callNumber === "") {
            return;
        }
        const onCall = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تماس با مشتری");
            }

        }
        clickToCall(callNumber, onCall)
    }
    function rowClick(item) { showCustomer(item.ID); }
    function showModalSMS() {
        const onGetMobile = (data) => {
            if (!data || !data.Data || !Array.isArray(data.Data)) {
                setErrorDialog(dispatch, data.Message ?? data.Error ?? "Error", "دریافت شماره های همراه");
                return;
            }
            const mobiles = data.Data.join(",");
            setModalSMS({
                show: true,
                to: mobiles,
                filterData: searchData.current
            })
        }
        searchCustomer_GetMobiles(searchData.current, onGetMobile);
    }
    function showModalNotice(code) {
        setModalNoticeData({ show: true, customerCode: code });
    }
    function toExcel() {
        const url = "api/CustomersAPI/GetCustomerByFilter";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("SearchCustomers", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getAllProvinces());
        dispatch(getCustomerBaseInfoes());
        if (filterData) {
            dispatch(searchCustomer(filterData));
        }
    }, []);
    return (
        <div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
            <br />
            <ModalNewNotice popData={modalNoticeData} setPopData={setModalNoticeData} />
            <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} templateType="customers" sendFromModel="customer" />
            <ModalChangeCustomerStatus show={showChangeStatus} setShow={setChangeStatusPop} customers={selectedCust} campaignID={selectedCampaign} />
            <ModalSelectUser popData={modalUsers} setUserPop={setModalUsers} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;
                    جستجوی مشتریان
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <div className='form-group col-md-2'>
                                <input placeholder='کد حساب' type='text' className='search-input' ref={register({})} name="Code" defaultValue={filterData?.Code ?? ""}></input>
                            </div>
                            <div className='form-group col-md-2'>
                                <input placeholder='کد اشتراک ' type='text' className='search-input' ref={register({})} name="SubscriptionCode" defaultValue={filterData?.SubscriptionCode ?? ""}></input>
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='نام' className="search-input" ref={register({})} name="FirstName" defaultValue={filterData?.FirstName ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='نام خانوادگی' className="search-input" ref={register({})} name="Name" defaultValue={filterData?.Name ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='موبایل' className="search-input" ref={register({})} name="Mobile" defaultValue={filterData?.Mobile ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='تلفن' className="search-input" ref={register({})} name="Phone" defaultValue={filterData?.Phone ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='کدملی' className="search-input" ref={register({})} name="NationalCode" defaultValue={filterData?.NationalCode ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                {baseInfoes === "PENDING" &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.GroupList && Array.isArray(baseInfoes.GroupList) &&
                                    <select className='search-input' placeholder='گروه مشتری' defaultValue={filterData?.GroupID ?? ""}
                                        ref={register({})} name="GroupID">
                                        <option value="">گروه را انتخاب کنید</option>
                                        {
                                            baseInfoes.GroupList.map((item, i) =>
                                                <option key={i} value={item.ID}>{item.Group}</option>
                                            )
                                        }
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                {baseInfoes === "PENDING" &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.JobList && Array.isArray(baseInfoes.JobList) &&
                                    <select className='search-input' placeholder='رسته شغلی' name="JobId" ref={register({})} defaultValue={filterData?.JobId ?? ""}>
                                        <option value="">رسته شغلی را انتخاب کنید</option>
                                        {
                                            baseInfoes.JobList.map((item, i) =>
                                                <option key={i} value={item.JobId}>{item.Job}</option>
                                            )
                                        }
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                {baseInfoes === "PENDING" &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.CampaignList && Array.isArray(baseInfoes.CampaignList) &&
                                    <select className='search-input' placeholder='کمپین فروش' defaultValue={filterData?.CampaignID ?? ""}
                                        ref={register({})} name="CampaignID">
                                        <option value="">کمپین فروش را انتخاب کنید</option>
                                        <option value={-1} style={{ color: "red" }}>عضو هیچ کمپینی نباشد</option>
                                        {
                                            baseInfoes.CampaignList.map((item, i) =>
                                                <option key={i} value={item.Item1}>{item.Item2}</option>
                                            )
                                        }

                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                {provinceList === "PENDING" &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {provinceList && Array.isArray(provinceList) &&
                                    <select className='search-input' placeholder='استان' ref={register({})} name="ProvinceID" defaultValue={filterData?.ProvinceID ?? ""}
                                        onChange={e => loadCityList(e.target.value)}>
                                        <option value="">استان را انتخاب کنید</option>

                                        {provinceList.map((item, i) =>
                                            <option key={i} value={item.Id}>{item.Name}</option>
                                        )}

                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                {cityList === "PENDING" &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {cityList && Array.isArray(cityList) &&
                                    <select className='search-input' placeholder='شهر' defaultValue={filterData?.CityID ?? ""}
                                        ref={register({})} name="CityID">
                                        <option value="">شهر را انتخاب کنید</option>
                                        {
                                            cityList.map((item, i) =>
                                                <option key={i} value={item.Id}>{item.Name}</option>
                                            )
                                        }
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                <input type="text" placeholder="آدرس" className="search-input" ref={register({})} name="Address" defaultValue={filterData?.Address ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <select className="search-input" ref={register({})} name="IsBlackListed" defaultValue={filterData?.IsBlackListed ?? ""}>
                                    <option value="">وضعیت لیست سیاه</option>
                                    <option value={false}>لیست سیاه نباشد</option>
                                    <option value={true} style={{ color: "red" }}>لیست سیاه باشد</option>
                                </select>
                            </div>
                            <div className="form-group col-md-2" >
                                {baseInfoes === "PENDING" &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.StatusList && Array.isArray(baseInfoes.StatusList) &&
                                    <select className="search-input" name="StatusID" ref={register({})}
                                        defaultValue={filterData?.StatusID ?? ""}>
                                        <option value="">وضعیت مشتری</option>
                                        {baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                    </select>
                                }
                            </div>
                        <div className="form-group col-md-2" >
                            <select className="search-input" name="Type" ref={register({})}
                                defaultValue={filterData?.Type ?? ""}>
                                <option key={-1} value=''>نوع را انتخاب کنید</option>
                                <option key={0} value='حقوقی'>حقوقی </option>
                                <option key={1} value='مرد'>مرد</option>
                                <option key={2} value='زن'>زن </option>
                            </select>
                        </div> 
                        <div className="form-group col-md-2" >
                            <select className="search-input" name="CustomerAccountType" ref={register({})}
                                defaultValue={filterData?.CustomerAccountType ?? ""}>
                                <option value="">ماهیت حساب را انتخاب کنید</option>
                                <option value={true}>بدهکار </option>
                                <option value={false}>بستانکار </option>
                            </select>
                        </div>                                                   
                            <div className="form-group col-md-2">
                                <input type="hidden" name="CreateByID" ref={register({})} readOnly value={createBy?.ID ?? filterData?.CreateByID ?? ""} />
                                <input className="search-input" placeholder="کاربر ثبت کننده"
                                    value={createBy?.Name ?? filterData?.CreateByName ?? ""} ref={register({})} name="CreateByName" />
                                <Button className="btn-input-tiny" onClick={showCreateBy} style={{ top: 4, left: 14 }}><List size={17} /></Button>
                            </div>
                            <div className="form-group col-md-2">
                                <input type="hidden" name="UpdateByID" ref={register({})} readOnly value={updateBy?.ID ?? filterData?.UpdateByID ?? ""} />
                                <input className="search-input" placeholder="کاربر ویرایش کننده"
                                    value={updateBy?.Name ?? filterData?.UpdateByName ?? ""} ref={register({})} name="UpdateByName" />
                                <Button className="btn-input-tiny" onClick={showUpdateBy} style={{ top: 4, left: 14 }}><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={createDateFrom} isGregorian={false} timePicker={false} className="search-input" placeholder="تاریخ ثبت از"
                                    value={/*filterData?.CreateDateFrom ? moment(filterData.CreateDateFrom) : */searchData.current.CreateDateFrom ? moment(searchData.current.CreateDateFrom) : null}
                                    onChange={value => { searchData.current.CreateDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={createDateTo} isGregorian={false} timePicker={false} className="search-input" placeholder="تاریخ ثبت تا"
                                    value={/*filterData?.CreateDateTo ? moment(filterData.CreateDateTo) :*/ searchData.current.CreateDateTo ? moment(searchData.current.CreateDateTo) : null}
                                    onChange={value => { searchData.current.CreateDateTo = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={updateDateFrom} isGregorian={false} timePicker={false} className="search-input" placeholder="تاریخ ویرایش از"
                                    value={/*filterData?.UpdateDateFrom ? moment(filterData.UpdateDateFrom) :*/ searchData.current.UpdateDateFrom ? moment(searchData.current.UpdateDateFrom) : null}
                                    onChange={value => { searchData.current.UpdateDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={updateDateTo} isGregorian={false} timePicker={false} className="search-input" placeholder="تاریخ ویرایش تا"
                                    value={/*filterData?.UpdateDateTo ? moment(filterData.UpdateDateTo) :*/ searchData.current.UpdateDateTo ? moment(searchData.current.UpdateDateTo) : null}
                                    onChange={value => { searchData.current.UpdateDateTo = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <Col md={2} className="form-group">
                                <select className="search-input" placeholder="ترتیب نمایش" defaultValue="ID" name="SortBy" ref={register({})}>
                                    <option value="ID">ترتیب ثبت-صعودی</option>
                                    <option value="ID DESC">ترتیب ثبت-نزولی</option>
                                    <option value="Name">نام خانوادگی-صعودی</option>
                                    <option value="Name DESC">نام خانوادگی-نزولی</option>
                                </select>
                            </Col>
                        </Row>

                        <div className="row mt-2">
                            <div>
                                <Button style={{ float: "right" }} className="group-Btn" type="submit"><Search size={15} />&nbsp;جستجوی مشتری</Button>
                                <Button className="group-Btn" variant="secondary" onClick={showModalSMS}><Envelope size={15} />&nbsp;ارسال پیامک به لیست</Button>
                            </div>
                        </div>
                    </form>
                    {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" /></div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData} searchMethod={(data) => dispatch(searchCustomer(data))}
                        reducerName="customerDataReducer" objectName="customerList" rowClick={rowClick} hasPaging={true} className="mt-0" style={{ whiteSpace: "nowrap" }} />
                </Card.Body>

            </Card>
        </div>
    );
}
export default SearchCustomer;